// extracted by mini-css-extract-plugin
module.exports = {"burgerIcon":"zn","cross":"zo","iconSVGWrapper":"zp","iconSVG":"zq","iconSVGDark":"zr"};